import { resolveSeasonalTheme } from "@/domain/seasonal"
import { atom } from "jotai"
import basicInfoAtom from "./basic-info"
import { minuteNowAtom, tenantTimezoneAtom } from "./tenant-clock"

/** Seasonal theme in force on the merchant calendar and region; null outside every window. */
export const activeSeasonalThemeAtom = atom((get) =>
  resolveSeasonalTheme({
    now: get(minuteNowAtom),
    timeZone: get(tenantTimezoneAtom),
    country: get(basicInfoAtom)?.address?.country,
  }),
)
